<template>
  <div id="app">
    <header>
      <div class="background-div"></div>
    </header>
    
    <div class="content">
      <Header msg="" />
      <CoinInfo />
      <UserWallet msg=""/>
      <Stake msg=""/>
      <AppFooter />
    </div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import UserWallet from './components/UserWallet.vue'
import CoinInfo from './components/CoinInfo.vue'
import AppFooter from './components/AppFooter.vue';
import Stake from './components/Stake.vue';

export default {
  name: 'App',
  components: {
    Header,
    UserWallet,
    CoinInfo,
    Stake,
    AppFooter
  }
}
</script>

<style scoped>
#app {
  font-family: 'Comic Sans MS', cursive, sans-serif; 
  color: #000000;
  background-color: #3a72af; 
  text-align: center;
  min-height: 100vh; 
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3%;
  margin-bottom: 3%;
  background-image: url('@/assets/platpusrocket3.gif');
  background-size: 300px 300px; 
}


.content {
  max-width: 800px; 
  width: 100%;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.9); 
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); 
}


.button {
  background-color: #ff7d31; 
  color: #fff;
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;
  display: inline-block;
  margin-top: 10px;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.button:hover {
  background-color: #e62d03; 
}



.background-div {
  width: 100%;
  height: 100vh;
  background-color: #000000;
  background-size: 100px 100px; 
  background-repeat: repeat;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1; 
}





</style>